module.exports = __webpack_public_path__ + "static/img/id-card-back.6cd492a9.png";